export type FacilityStatus = {
	readonly value: string;
	readonly label: string;
};

export type FacilityPayload = {
	readonly id: number;
	readonly name: string;
	readonly address: string | null;
	readonly phoneNumber: string | null;
	readonly status: FacilityStatus;
	readonly assignedUserCount: number;
};

export type FacilitiesFetchedPayload = FacilityPayload[];

export type FacilitiesFetchedAction = {
	type: 'FACILITIES_FETCHED';
	payload: FacilitiesFetchedPayload;
	organizationId: number;
};

export default (payload: FacilitiesFetchedPayload, organizationId: number): FacilitiesFetchedAction => ({
	type: 'FACILITIES_FETCHED',
	payload,
	organizationId,
});
